export default {

    state: () => ({
        favorites: [],
    }),

    actions: {
        ADD_FAVS_ITEM: (context, payload) => {
            context.commit('ADD_TO_FAVS', payload);
        },
        DEL_FAVS_ITEM: (context, payload) => {
            context.commit('DELETE_FAVS_ITEM', payload);
        },
        SET_FAVS_DATA: (context, payload) => {
            context.commit('SET_FAVS', payload);
        },
        GET_FAVS     : async (context) => {
            fetch("/api/favorites/")
                .then(async response => await response.json())
                .then(resp => {
                    if(resp.success !== true)
                        alert(resp.message)
                    else
                    {
                        if(resp.data)
                        {
                            context.commit('SET_FAVS', resp.data);
                        }
                    }
                })
        },
    },

    mutations: {
        ADD_TO_FAVS     : (state, item) => {
            let formData = new FormData();
            formData.append('id', item.ID);
            fetch("/api/favorites/items/add/", {method: 'POST', body: formData})
                .then(response => response.json())
                .then(async resp => {
                    if(resp.success !== true)
                        window.toast.error('Ошибка: ' + resp.message);
                    else
                    {
                        state.favorites.push(item);
                        window.toast.success('<a href="/personal/favorites/">Товар успешно добавлен в избранное!</a>');
                    }
                });
        },
        DELETE_FAVS_ITEM: (state, id) => {
            let formData = new FormData();
            formData.append('id', id);
            fetch("/api/favorites/items/delete/", {method: 'POST', body: formData})
                .then(response => response.json())
                .then(async resp => {
                    if(resp.success !== true)
                        window.toast.error('Ошибка: ' + resp.message);
                    else
                    {
                        let itemIndex = -1;
                        state.favorites.forEach((el, index) => {
                            if(parseInt(id) === parseInt(el.ID))
                            {
                                itemIndex = index;
                                return;
                            }
                        });
                        if(itemIndex !== -1)
                            state.favorites.splice(itemIndex, 1);
                        window.toast.success('<a href="/personal/favorites/">Товар успешно удален из избранного!</a>');
                    }
                });
        },
        SET_FAVS        : (state, favs) => {
            state.favorites = favs;
        },
    },

    getters: {}

}